import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const DashboardDefault = Loadable(lazy(() => import('adminViews/Dashboard')));
const Success = Loadable(lazy(() => import('views/PaymentIntegration/Success')))
const Cancel = Loadable(lazy(() => import('views/PaymentIntegration/Cancel')))
const Invoice = Loadable(lazy(() => import('utils/Invoice')))
const PaymentRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: 'dashboard/payment',
            children: [
                {
                    path: 'success',
                    element: <Success />
                },
                {
                    path: 'cancel',
                    element: <Cancel />
                },
                {
                    path: 'invoice/:id',
                    element: <Invoice />
                }
            ]
        }
    ]
};

export default PaymentRoutes;
